import styled, { css } from 'styled-components'
import { Transition } from 'utils/constants'

const buttonSizeStyles = {
  small: css`
    height: 24px;
    padding-inline: 8px;
    font-size: 12px;
  `,

  medium: css`
    height: 32px;
    padding-inline: 12px;
  `,

  large: css`
    height: 40px;
    padding-inline: 24px;
  `,
}

const resetButtonIconStyles = css`
  && svg {
    margin-right: 0;
    top: 0;
  }
`

const buttonThemeStyles = {
  base: css`
    color: var(--p-neutral-100);
    background-color: var(--p-blue-500);

    &:hover {
      background-color: var(--p-blue-450);
    }
  `,

  borderGrey: css`
    color: var(--t-button-border-grey-color);
    border: 1px solid var(--t-button-border-grey-bg);

    &:hover {
      border-color: var(--t-button-border-grey-hover-bg);
    }
  `,

  borderRed: css`
    color: var(--p-pink-480);
    border: 1px solid var(--p-pink-480);

    &:hover {
      border-color: var(--p-pink-480);
    }
  `,

  borderBlue: css`
    color: var(--t-button-border-blue);
    border: 1px solid var(--t-button-border-blue);

    &:hover {
      color: var(--t-link-hover);
      border-color: var(--t-link-hover);
    }
  `,

  borderNone: css`
    color: var(--t-button-border-none-text);

    &:hover {
      color: var(--t-link-hover);
    }
  `,

  colorGray: css`
    border: 1px solid var(--t-surface-2);
    background-color: var(--t-surface-2);

    &:hover {
      border-color: var(--t-input-hover);
    }
  `,

  colorGrayLight: css`
    background-color: var(--t-button-add-to-archive);
    color: var(--t-text-primary);

    &:hover {
      background-color: var(--t-button-add-to-archive-hover);
    }
  `,

  colorNone: css`
    border: 1px solid inherit;
    background-color: inherit;
    color: var(--p-neutral-500);

    &:hover {
      background-color: var(--t-button-more-action-hover-bg);
    }
  `,

  colorNoneTitle: css`
    border: 1px solid inherit;
    background-color: inherit;
    color: var(--t-checklist-button-title-color);

    &:hover {
      background-color: var(--t-button-more-action-hover-bg);
    }
  `,

  icon: css`
    height: fit-content;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--t-td-button-icon-color);

    ${resetButtonIconStyles}

    &:hover {
      color: var(--t-td-button-task-sidebar-icon-hover);
    }
  `,

  iconTemplatesHint: css`
    height: fit-content;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--t-description-templates-hint-close-button-color);

    ${resetButtonIconStyles}

    &:hover {
      color: var(--t-td-button-task-sidebar-icon-hover);
    }
  `,

  downloadButton: css`
    padding: 0;
    width: 40px;
    height: 40px;
    background: var(--t-td-button-icon-bg);
    border-radius: 6px;
    cursor: pointer;
    transition: 0.3s ease-out;
    color: var(--t-td-button-icon-color);
    display: flex;
    justify-content: center;
    align-items: center;

    ${resetButtonIconStyles}

    &:hover {
      transition: 0.3s all ease;
      color: var(--t-td-button-task-sidebar-icon-hover);
    }
  `,

  link: css`
    color: var(--t-link-color);
    font-size: inherit;
    line-height: inherit;

    &:hover {
      color: color-mix(in srgb, var(--p-blue-400) 80%, black 20%);
    }
  `,
}

export const ButtonStyled = styled.button`
  width: 100%;
  cursor: pointer;
  position: relative;
  background: transparent;
  border-radius: 6px;
  transition: ${Transition.ms300};
  font-size: 14px;

  ${({ $size }) => buttonSizeStyles[$size]}
  ${({ $theme }) => buttonThemeStyles[$theme]}

  ${({ $minWidth }) =>
    $minWidth &&
    css`
      min-width: ${$minWidth};
    `}

  ${({ $loading }) =>
    $loading === 'true' &&
    css`
      pointer-events: none;

      span,
      svg {
        opacity: 0;
      }
    `}
    svg {
    position: relative;
    top: -1px;
    vertical-align: middle;
    margin-right: 9px;
  }

  &:disabled {
    cursor: default;
    border: none;

    html[data-theme='light'] & {
      background: #eef5fc;
      color: #abbed1;
    }

    html[data-theme='dark'] & {
      background: #383838;
      color: #787878;
    }
  }
`

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;

  button {
    &:not(:last-child) {
      margin-right: 8px;
    }
  }
`

export const ButtonLoader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('/images/loading-white.svg');
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: center center;
`
